module.exports = __webpack_public_path__ + "media/images/cabecera1-ccc3a1b0.png";